import { render, staticRenderFns } from "./CanceledPostDocs.vue?vue&type=template&id=19701b0d&scoped=true&"
import script from "./CanceledPostDocs.vue?vue&type=script&lang=js&"
export * from "./CanceledPostDocs.vue?vue&type=script&lang=js&"
import style0 from "./CanceledPostDocs.vue?vue&type=style&index=0&id=19701b0d&prod&lang=css&"
import style1 from "./CanceledPostDocs.vue?vue&type=style&index=1&id=19701b0d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19701b0d",
  null
  
)

export default component.exports